import * as React from "react";

export const getAddressListTypes = (isMapBased=true) => [
    {
        value: "upload",
        icon: require("./listtype-upload.png"),
        label: "Upload List",
        checkCountry: () => true,
    },
    {
        value: "radius",
        icon: require("./listtype-radius.png"),
        label: "Radius List",
        checkCountry: (country) => country === "US",
    },
    {
        value: "street",
        icon: require("./listtype-street.png"),
        label: "Street List",
        checkCountry: (country) => country === "US",
    },
    {
        value: "demographics",
        icon: require("./listtype-demographics.png"),
        label: "Demographics",
        addressListTypes: ["targeted single", "targeted multiple"],
        checkCountry: (country) => country === "US",
    },
    {
        value: "saturation",
        icon: require("./listtype-eddm.png"),
        label: "Neighborhood Search",
        bannerMsg: <>FORMERLY<br />EDDM/SATURATION</>,
        checkCountry: (country) => country === "US",
    },
    {
        value: "CRM",
        icon: require("./listtype-crm.png"),
        label: "Import CRM List",
        checkCountry: (country) => country === "US",
    },
    {
        value: "co-op/condo building",
        icon: require("./listtype-condo.png"),
        label: "Co-op/Condo",
        checkCountry: (country) => country === "US",
    },
    {
        value: "new homeowners",
        icon: require("./listtype-homeowners.svg"),
        label: "New Homeowners",
        badge: "NEW",
        checkCountry: (country) => country === "US",
    }
];

export const filterAddressListTypes = (isTypeAllowed) => (
    (type) => type.addressListTypes ? (
        !type.addressListTypes.find((t) => !isTypeAllowed(t))
    ) : (
        isTypeAllowed(type.value)
    )
);
